import React from "react";
import Layout from "../components/layout";
import { useMetadata } from "../seo";
export default function AppLanding({ appName, packageId, path }) {
  useMetadata(
    `${appName} | Quantingo`,
    `/${path}`,
    `Find ${appName} by Quantingo on Google Play, or contact us for application support.`,
  );
  return (
    <Layout>
      <div className="container support-page">
        <p className="eyebrow">Quantingo / Android applications</p>
        <h1>{appName}</h1>
        <p>
          If you followed an app link, install or open {appName} on your Android
          device to continue.
        </p>
        <a
          className="button"
          href={`https://play.google.com/store/apps/details?id=${packageId}`}
        >
          Find {appName} on Google Play <span aria-hidden="true">↗</span>
        </a>
        <p>
          Need help? Email{" "}
          <a href="mailto:contact@quantingo.com">contact@quantingo.com</a> with
          the app name and a description of the issue.
        </p>
        <a href="/quantingoapps">All Quantingo applications</a>
      </div>
    </Layout>
  );
}
